import { render, staticRenderFns } from "./ApiIntegrationCard.vue?vue&type=template&id=ab844f0a&scoped=true"
import script from "./ApiIntegrationCard.vue?vue&type=script&lang=ts"
export * from "./ApiIntegrationCard.vue?vue&type=script&lang=ts"
import style0 from "./ApiIntegrationCard.vue?vue&type=style&index=0&id=ab844f0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab844f0a",
  null
  
)

export default component.exports